import * as React from "react"
import { PrimaryButton } from "@humanpredictiveintelligence/myqvt-library"
import { Dialog, DialogContent } from "@material-ui/core"
import { t } from "ttag"

import { CustomQuestion, CustomQuestionPayload } from "models/CustomQuestions"
import * as Styles from "../QuestionDialog.styles"

export const QuestionNpsDialog: React.FC<QuestionNpsDialogProps> = (props) => {
  const [ name, setName ] = React.useState(props.customQuestion?.name ?? "")
  const isEdition = Boolean(props.customQuestion)

  const canValidate = name.trim().length > 0

  return (
    <Dialog
      open
      onClose={props.onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogContent>
        <Styles.Title>
          {isEdition ? t`Edit NPS question` : t`Create NPS question`}
        </Styles.Title>

        <Styles.Introduction>
          {t`You are about to create an NPS question. This is a recommendation score that will allow users to rate 
          your organization on a scale from 0 to 10. `}
        </Styles.Introduction>

        <Styles.Field>
          <Styles.Label>{t`Question :`}</Styles.Label>

          <Styles.Input
            value={name}
            onChange={event => setName(event.target.value)}
            disabled={props.isLoading}
          />
        </Styles.Field>

        <Styles.Warning>
          {t`Please note: if your content contains too many characters, it may not display properly`}
        </Styles.Warning>

        <Styles.Actions>
          <PrimaryButton
            onClick={props.onClose}
            disabled={props.isLoading}
            destructive
          >
            {t`Close`}
          </PrimaryButton>

          <PrimaryButton
            isLoading={props.isLoading}
            disabled={!canValidate || props.isLoading}
            onClick={() =>
              props.onValidate({
                name: name.trim(),
              })
            }
          >
            {t`Validate`}
          </PrimaryButton>
        </Styles.Actions>
      </DialogContent>
    </Dialog>
  )
}

export interface QuestionNpsDialogProps {
  customQuestion?: CustomQuestion,
  isLoading?: boolean,
  onClose: () => void,
  onValidate: (payload: CustomQuestionPayload) => void | Promise<void>,
}
